
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/60w-solar-panel",
      function () {
        return require("private-next-pages/60w-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/60w-solar-panel"])
      });
    }
  